import apiService from './apiService';
import { GET_ACTIONS } from './constants';

import { processApiRequest } from './../Common/saga';

export function* getActions() {
    yield processApiRequest(GET_ACTIONS, () => apiService.getActions());
}
